import React from 'react';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ScrollToTop = ({ elementId }) => (
  <button
    type="button"
    className="scroll-to-top"
    onClick={ () => {
      if (elementId) {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    } }
    aria-label="Scroll to Top"
  >
    <FontAwesomeIcon icon="arrow-up" />
  </button>);

ScrollToTop.propTypes = {
  elementId: PropTypes.string
};

ScrollToTop.defaultProps = {
  elementId: null
};

export default ScrollToTop;
